const INITIAL_STATE = { 
    registro: {}, 
    modoTela: 'lista', 
	aguardando: false,
    lista: [], 
    listaUnidade: [],
    listaProduto: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'FECHAMENTO_ESTOQUE_DIARIO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};
        
        case 'FECHAMENTO_ESTOQUE_DIARIO_SET_AGUARDANDO':
            return { ...state,
                aguardando: action.payload
            };

        case 'FECHAMENTO_ESTOQUE_DIARIO_LISTADO':
            return { ...state, lista: action.payload.data };

        case 'FECHAMENTO_ESTOQUE_DIARIO_UNIDADE_SELECT_LISTADO':
			return {
				...state,
				listaUnidade: action.payload.data
            };

        case 'FECHAMENTO_ESTOQUE_DIARIO_PRODUTO_SELECT_LISTADO':
			return {
				...state,
				listaProduto: action.payload.data
            };
                      
        default:
            return state;
    }
}
